import React from 'react';
import { SettingsComponentProps } from '../SettingsRouter.component';
import NoDataMessage from '../../feedback/NoDataMessage.component';

const PageNotFound: React.FC<SettingsComponentProps> = () => {
  return <NoDataMessage message="Page Not Found" />;
};

export default PageNotFound;
